import moment from "moment";
import React, { useEffect, useState } from "react";
// import toast from "react-hot-toast";
// import appointmentService from '../../../../../services/appointmentService';
import strings from "../../../../Utils/strings";
// import Widgets from '../../../../widgets';
import "../../../../Components/ApproveAppointment/ApproveAppointment.css";
import "./generateCertificate.css";
import { t } from "../../../../Utils/translate";

// function GenerateCertificate(props) {
function GenerateCertificate(props) {
  // const { id, appointment, backToAppointment } = props
  const [unitFor, setUnitFor] = useState(strings.generateCertificate.work);
  const [certificateNumber, setCertificateNumber] = useState("");
  const [patientName, setPatientName] = useState("");
  const [patientAge, setPatientAge] = useState("");
  const [remarks, setRemarks] = useState("");
  const [identificationNumber, setIdentificationNumber] = useState("");
  const [referenceNumber, setReferenceNumber] = useState("");
  const [sDate, setSDate] = useState("");
  const [eDate, setEDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let date = new Date();
    date.setDate(date.getDate());
    let currentDate = date;
    let startDate = moment(currentDate).format("YYYY-MM-DD");
    setSDate(startDate);
    let endDate = moment(currentDate).format("YYYY-MM-DD");
    setEDate(endDate);
    setPatientName("firstName" + " " + "lastName");
    // setPatientName(appointment.patientId.firstName + " " + appointment.patientId.lastName)
    // setPatientAge(getAgeFromDateOfBirth(appointment.patientId.dateOfBirth).toString())
    setPatientAge(18);
  }, []);

  function getAgeFromDateOfBirth(patientAge) {
    return moment().diff(patientAge, "years") ? moment().diff(patientAge, "years") : "";
  }

  function disableButton() {
    let returnValue = false;
    if (certificateNumber.length > 0 && patientName.length > 0 && patientAge.length > 0 && identificationNumber.length > 0 && referenceNumber.length > 0 && sDate <= eDate) {
      returnValue = false;
    } else {
      returnValue = true;
    }
    return returnValue;
  }

  // async function createCertificate() {
  //     try {
  //         setIsLoading(true)
  //         let body = {
  //             appointmentId: id,
  //             patientName: patientName,
  //             patientAge: patientAge,
  //             patientRefNumber: referenceNumber,
  //             certificateNumber: certificateNumber,
  //             isUnfitFor: unitFor,
  //             remarks: remarks,
  //             identificationNumber: identificationNumber,
  //             treatmentDuration: {
  //                 startDate: sDate,
  //                 endDate: eDate,
  //                 totalDays: moment(eDate).diff(moment(sDate), 'days') + 1
  //             }
  //         }
  //         let response = await appointmentService.createCertificate(body);
  //         if (response) {
  //             if (response && response.status == true) {
  //                 toast.dismiss();
  //                 toast.success(strings.generateCertificate.certificateGenerationMsg)
  //                 backToAppointment();
  //             } else {
  //                 toast.dismiss();
  //                 toast.error(response.data.error_message)
  //             }
  //         }
  //         setIsLoading(false)
  //     } catch (error) {
  //         setIsLoading(false)
  //         toast.dismiss();
  //         toast.error(error.message);
  //     }
  // }

  return (
    <>
      {/* {isLoading ? <Widgets.CircularLoader /> : ""} */}
      <div className="p-1">
        <div className="d-flex align-items-center">
          {/* <i className="ri-hotel-bed-line tab-left-icon-no-hover"></i> <span className='patient-name'>{appointment.patientId.firstName + " " + appointment.patientId.lastName} */}
          <i className="ri-hotel-bed-line tab-left-icon-no-hover"></i> <span className="patient-name">{"FirstName" + " " + "LastName"}</span>
        </div>

        <div className="my-3">
          <div className="input-group input-group-lg">
            <input
              type="text"
              className="form-control generate-text"
              placeholder={t("Certificate Number*")}
              // onChange={(e) => {
              //     setCertificateNumber(e.target.value.trimStart())
              // }}
              // value={certificateNumber}
            />
          </div>
        </div>
        <div className="mb-3">
          <div className="input-group input-group-lg">
            <input
              type="text"
              className="form-control generate-text"
              placeholder={t("Name In Certificate*")}
              // onChange={(e) => {
              //     setPatientName(e.target.value.trimStart())
              // }}
              // value={patientName}
            />
          </div>
        </div>
        <div className="mb-3">
          <div className="input-group input-group-lg">
            <input
              type="text"
              className="form-control generate-text"
              placeholder={t("Age Of Patient*")}
              // onChange={(e) => {
              //     setPatientAge(e.target.value.trimStart())
              // }}
              // value={patientAge}
            />
          </div>
        </div>
        <div className="mb-3">
          <div className="input-group input-group-lg">
            <input
              type="text"
              className="form-control generate-text"
              placeholder={t("Remarks")}
              // onChange={(e) => {
              //     setRemarks(e.target.value.trimStart())
              // }}
              // value={remarks}
            />
          </div>
        </div>
        <div className="mb-3">
          <div className="input-group input-group-lg">
            <input
              type="text"
              className="form-control generate-text"
              placeholder={t("NRIC/Passport No.*")}
              // onChange={(e) => {
              //     setIdentificationNumber(e.target.value.trimStart())
              // }}
              // value={identificationNumber}
            />
          </div>
        </div>
        <div className="mb-3">
          <div className="input-group input-group-lg">
            <input
              type="text"
              className="form-control generate-text"
              placeholder={t("Patient Reference No.*")}
              // onChange={(e) => {
              //     setReferenceNumber(e.target.value.trimStart())
              // }}
              // value={referenceNumber}
            />
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center unitFor mb-3">
          <div>
            <span className="label-texts">{t("Certificate Use for:")}</span>
          </div>
          <div
          // onChange={(e) => {
          //     setUnitFor(e.target.value);
          // }}
          >
            <div className="d-flex">
              <div className="d-flex align-items-center me-4">
                <input type="radio" value={strings.generateCertificate.work} name="unitFor" className="app-input" checked={unitFor === strings.generateCertificate.work} />
                <label className="label-texts ms-2">{t("work")}</label>
              </div>
              <div className="d-flex align-items-center me-4">
                <input type="radio" value={strings.generateCertificate.college} name="unitFor" className="app-input" checked={unitFor === strings.generateCertificate.college} />
                <label className="label-texts ms-2">{t("college")}</label>
              </div>
              <div className="d-flex align-items-center ">
                <input type="radio" value={strings.generateCertificate.school} name="unitFor" className="app-input" checked={unitFor === strings.generateCertificate.school} />
                <label className="label-texts ms-2">{t("school")}</label>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-between unitFor mb-3">
          <div>
            <span className="label-texts">{t("Period*")}</span>
          </div>
          <div className="d-flex">
            <div className="me-4">
              <span className="date-label me-2">{t("Label From")}</span>
              <input
                className="date-values p-1"
                type="date"
                value={sDate}
                max={eDate}
                onChange={(e) => {
                  // setSDate(e.target.value)
                }}
              ></input>
            </div>

            <div>
              <span className="date-label me-2">{t("Label To")}</span>
              <input
                type="date"
                className="date-values p-1"
                value={eDate}
                min={sDate}
                onChange={(e) => {
                  // setEDate(e.target.value)
                }}
              ></input>
            </div>
          </div>
        </div>

        <div>
          <span className="date-label">{t("Generated Medical Certificate Note")}</span>
        </div>

        <div className="col-12 d-flex mt-4">
          <button
            className="dialog-btn dialog-btn-type-bordered me-2"
            onClick={() => {
              // backToAppointment()
            }}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            className="btn dialog-btn dialog-btn-type-filled btn-clinic-next"
            // disabled={disableButton()}
            onClick={() => {
              // createCertificate()
            }}
          >
            {t("Submit")}
          </button>
        </div>
      </div>
    </>
  );
}

export default GenerateCertificate;
